import React, { Component } from 'react';
import { MDBBtn, MDBCard, MDBCardBody, MDBIcon, MDBRow, MDBCol, MDBCardText, MDBCardImage, MDBCardTitle, MDBJumbotron, MDBContainer } from 'mdbreact';
import DataLayer from '../Utilities/DataLayer';

class SFLanding extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasNotifications: false,
            mobiNotifications: [],
            copayments: []
        }

        this.TMAUser = JSON.parse(localStorage.getItem("TMAUser"));
        this.appSettings = require('../appsettings.json');
        this.props.loaderOff();
        this.placeOrderClick = this.placeOrderClick.bind(this);
        this.profileClick = this.profileClick.bind(this);
        this.onPromotionClick = this.onPromotionClick.bind(this);
        this.onConnectClick = this.onConnectClick.bind(this);
        this.onGetUpClick = this.onGetUpClick.bind(this);
        this.onSocialClick = this.onSocialClick.bind(this);
        this.onTrainingMaterialClick = this.onTrainingMaterialClick.bind(this);
        this.onTrackSalesClick = this.onTrackSalesClick.bind(this);
        this.onCoPaymentClick = this.onCoPaymentClick.bind(this);
    }

    async componentWillMount() {
        this.props.loaderOn();
        var dl = new DataLayer();
        let result = await dl.Get('/demonstrator/getnotifications', 200);
        let coPaymentResult = await dl.Get('/copayment/GetCopayment', 200);
        console.log('copayments', coPaymentResult);
        this.setState({
            hasNotifications: result.data.length > 0 ? true : false,
            mobiNotifications: result.data,
            copayments: coPaymentResult.data
        });
        this.props.loaderOff();
    }

    onTrackSalesClick() {
        this.props.history.push({
            pathname: '/salesforce/myorders'
        })
    }

    onTrainingMaterialClick() {
        let path = '/salesforce/media'
        switch (this.TMAUser.data.statusCode1.toUpperCase()) {
            case 'T':
                this.props.setNavParam("New Team Leader");
                path = path + '/8'
                break
            case 'M':
                if (this.TMAUser.data.statusCode2.toUpperCase() == 'N' || this.TMAUser.data.statusCode2.toUpperCase() == 'C') {
                    this.props.setNavParam("New Manager");
                    path = path + '/5'
                }
                if (this.TMAUser.data.statusCode2.toUpperCase() == 'B') {
                    this.props.setNavParam("New Senior Manager");
                    path = path + '/6'
                }
                if (this.TMAUser.data.statusCode2.toUpperCase() == 'A') {
                    this.props.setNavParam("New Executive Manager");
                    path = path + '/7'
                }
                break;
            case 'D':
                this.props.setNavParam("New Demonstrator");
                path = path + '/4'
                break;
        }
        this.props.history.push({
            pathname: path
        })

    }

    placeOrderClick() {
        this.props.setNavParam("All Categories");
        this.props.history.push({
            pathname: '/salesforce/shop/-1'
        })
    }

    profileClick() {
        this.props.history.push({
            pathname: '/salesforce/personalInfo'
        })
    }

    onCoPaymentClick() {
        this.props.history.push({
            pathname: '/salesforce/copaymentDetails'
        })
    }

    onPromotionClick() {
        this.props.setNavParam("Monthly Specials");
        this.props.history.push({
            pathname: '/salesforce/media/2'
        })
    }

    async onSocialClick() {
        var dl = new DataLayer();
        let response = await dl.Get('/demonstrator/GetTuppSocialParams/');

        document.getElementById("id").value = response.data.id;
        document.getElementById("url").value = response.data.url;
        document.getElementById("first_name").value = response.data.firstName;
        document.getElementById("last_name").value = response.data.lastName;
        document.getElementById("email").value = response.data.email;
        document.getElementById("lang").value = response.data.lang;
        document.getElementById("country").value = response.data.country;
        document.getElementById("t").value = response.data.timestamp;
        document.getElementById("h").value = response.data.hash;
        document.getElementById("socialForm").submit();
    }

    onGetUpClick() {
        this.props.history.push({
            pathname: '/salesforce/getup'
        })
    }

    async onConnectClick() {
        var dl = new DataLayer();
        let myTesterDDDJDJ = "";
        let response = await dl.Get('/demonstrator/GetConnectParams/');
        let mytester = "";
        this.setState({
            dealerId: response.data.dealerId,
            Target: response.data.target,
            connectURL: response.data.url,
            Signature: response.data.signature,
            Lang: response.data.language,
            Country: response.data.country,
            Timestamp: response.data.timestamp
        });
        let connectUrl = this.props.getConnectUrl();
        console.log(this.props.connectUrl + "?DealerUID=" + this.state.dealerId + "&TimeStamp=" + this.state.Timestamp + "&Target=" + this.state.Target + "&Signature=" + this.state.Signature)
        document.getElementById("connectForm").action = connectUrl + "?DealerUID=" + this.state.dealerId + "&TimeStamp=" + this.state.Timestamp + "&Target=" + this.state.Target + "&Signature=" + this.state.Signature;
        document.getElementById("connectForm").submit();
    }

    render() {
        let landingMsg = ""
        let bgColor = "rgb(227, 3, 133)";
        switch (this.appSettings.Environment) {
            case 'Test':
                landingMsg = "Welcome To MOBI-Test Sales Force Website";
                bgColor = "rgb(3, 130, 64)";
                break;
            case 'Production':
                landingMsg = "Welcome To MOBI Sales Force Website";
                break;
            case 'Dev':
                landingMsg = "Welcome To MOBI-Dev Sales Force Website";
                bgColor = "rgb(3, 130, 64)";
                break;
            default:
                break;
        }
        return (


            <div>
                <div className="text-center" style={{ backgroundColor: bgColor, color: "white" }} size="fluid">

                    <h2 className="display-4">{landingMsg}</h2>


                </div>
                <div hidden={!this.state.hasNotifications}>
                    {
                        this.state.mobiNotifications.map((noti) => {
                            const myElement = noti.ssfNotification
                            return (
                                <div class="row" style={{ paddingBottom: "9px" }}>
                                    <div class="col">
                                        <div class="text-center" id="rcornersIPaper" style={{ color: "white", fontSize: "15px", background: "rgb(49, 143, 53)" }}>
                                            <div dangerouslySetInnerHTML={{ __html: myElement }} >

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }

                </div>
                <div class="row" style={{ paddingBottom: "9px" }}>
                    <div hidden={!this.props.discountAssigned} class="col-6">
                        <div onClick={this.placeOrderClick} class="text-center" id="rcornersOrange" style={{ color: "white" }}>
                            <span style={{ fontSize: "50px" }}><MDBIcon icon="shopping-cart" /></span>
                            <div>Place An Order</div>
                        </div>
                    </div>

                    <div class="col">
                        <div onClick={this.onTrackSalesClick} class="text-center" id="rcornersBlue" style={{ color: "white" }}>
                            <span style={{ fontSize: "50px" }}><MDBIcon icon="sliders-h" /></span>
                            <div>Track Your Sales</div>
                        </div>
                    </div>

                </div>
                <div class="row" style={{ paddingBottom: "9px" }}>
                    <div class="col-6">
                        <div onClick={this.onPromotionClick} class="text-center" id="rcornersTurq" style={{ color: "white" }}>
                            <span style={{ fontSize: "50px" }}><MDBIcon far icon="comment-alt" /></span>
                            <div>On Promotion</div>
                        </div>
                    </div>
                    <div class="col-6">
                    <div onClick={this.profileClick} class="text-center" id="rcornersCyan" style={{ color: "white" }}>
                        <span style={{ fontSize: "50px" }}><MDBIcon far icon="star" /></span>
                        <div>My Profile</div>
                        </div>
                        </div>
                    {/*<div class="col-6">*/}
                    {/*    <div onClick={this.onTrainingMaterialClick} class="text-center" id="rcornersPurple" style={{ color: "white" }}>*/}
                    {/*        <span style={{ fontSize: "50px" }}><MDBIcon icon="graduation-cap" /></span>*/}
                    {/*        <div>Training Material</div>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                </div>
                <div class="row">
                    <div class="col-6">
                        {/*<div class="row" style={{ paddingBottom: "5px" }}>*/}
                        {/*    <div class="col">*/}
                        {/*        <div onClick={this.onSocialClick} class="text-center" id="rcornersBlack" style={{ color: "white", fontSize: "15px" }}>*/}
                        {/*            <div>Tupp Social</div>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}

                        <div hidden={ this.state.copayments.length === 0} style={{ paddingBottom: "5px" }} class="row">
                        {/*<div hidden="false" style={{ paddingBottom: "5px" }} class="row">*/}
                            <div class="col">
                                <div onClick={this.onCoPaymentClick} class="text-center" id="rcornersGreen" style={{ color: "white" }}>
                                    <div>Co-Payments</div>
                                    <span style={{ fontSize: "50px" }}><MDBIcon fas icon="hand-holding-usd" /></span>
                                    <div class="row">
                                        {this.state.copayments.map(item => {
                                            return (<div class="col-12" key={item.coPaymentId}>{item.coPaymentDescription}: Ordering Open From {item.orderingOpenFrom} to { item.orderingOpenTo}</div>)
                                        })}
                                    </div>
                                    
                                </div>
                            </div>
                        </div>

                        {/*<div hidden={!this.props.share} style={{ paddingBottom: "5px" }} class="row">*/}
                        {/*    <div class="col">*/}
                        {/*        <div onClick={this.onConnectClick} class="text-center" id="rcornersBlack" style={{ color: "white", fontSize: "15px" }}>*/}
                        {/*            <div>Connect</div>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        {/*<div class="row">*/}
                        {/*    <div class="col">*/}
                        {/*        <div onClick={this.onGetUpClick} class="text-center" id="rcornersBlack" style={{ color: "white", fontSize: "15px" }}>*/}
                        {/*            <div><img height="25px" src={require('../Assets/Images/GetupII.png')} /></div>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                    </div>
                    <div class="col-6">
                        {/*<div onClick={this.profileClick} class="text-center" id="rcornersCyan" style={{ color: "white" }}>*/}
                        {/*    <span style={{ fontSize: "50px" }}><MDBIcon far icon="star" /></span>*/}
                        {/*    <div>My Profile</div>*/}
                        {/*</div>*/}
                        {/* { */}
                        {/*     TuppConnect Rica is only available for South African market, hence the condition * /}
                       {/*     JSON.parse(localStorage.getItem("TMAUser")).data.countryId === 6 && */}
                        {/*     <div className="mt-2"> */}
                        {/*         <a href="https://portal.tuppconnect.co.za/" target="_blank"> */}
                        {/*             <div class="text-center" id="rcornersBlue" style={{ color: "white", fontSize: "15px" }}> */}
                        {/*                 <div>TuppConnect Rica</div> */}
                        {/*             </div> */}
                        {/*         </a> */}
                        {/*     </div> */}
                        {/* } */}
                    </div>

                </div>
            </div>

        )
    }
}

export default SFLanding;